export var groupBy = function (list, getKey) {
    var map = new Map();
    list.forEach(function (item) {
        var key = getKey(item);
        var collection = map.get(key);
        if (collection === undefined) {
            map.set(key, [item]);
        }
        else {
            collection.push(item);
        }
    });
    return map;
};
